<h1 mat-dialog-title *ngIf="action===dialogActions.ADD">{{ 'component.addMainBody' | translate }}</h1>
<h1 mat-dialog-title *ngIf="action===dialogActions.EDIT">{{ 'component.editMainBody' | translate }}
</h1>
<mat-dialog-content [formGroup]="addEditMainBodyForm">

  <app-component-sub-html-template [form]="addEditMainBodyForm" [componentSubtypes]="componentSubtypes"
    [manufacturingCountries]="manufacturingCountries" [canEditForm]="canEditForm" [isMainBody]="true"
    [componentTypeSelectionLabel]="'component.fields.ofMainBody' | translate">
  </app-component-sub-html-template>

  <mat-card>
    <mat-card-content class="table-container-wide">
      <app-multi-material-table [parentCompositeMaterial]="compositeMaterial"
        [allMaterialFunctions]="allMaterialFunctions" [allColors]="allColors" [allManifestations]="allManifestations"
        [callerId]="callerId" [manufacturingCountry]="selectedManufacturingCountry"
        [packagingUnitTypeId]="packagingUnitTypeId" [canEditForm]="canEditForm" [isFirstOpen]="!isEditing"
        (totalWeightChanged)="totalWeightChanged($event, addEditMainBodyForm)" (materialChanged)="materialChanged($event)">
      </app-multi-material-table>
    </mat-card-content>
  </mat-card>
</mat-dialog-content>

<mat-dialog-actions>
  <button *ngIf="action===dialogActions.ADD" (click)="doAction()" mat-raised-button type="submit" color="primary">
    {{ 'common.buttons.add' | translate }}</button>
  <button *ngIf="action===dialogActions.EDIT" (click)="doAction()" mat-raised-button type="submit" color="primary"
    [disabled]="!canEditForm">{{ 'common.buttons.save' | translate }}</button>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.cancel' | translate }}</button>
</mat-dialog-actions>
